"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.azureRegionsRaw = exports.azureRegions = exports.azureRegionSchemaRaw = exports.azureRegionSchema = void 0;
var z = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// DO NOT EDIT!
// This file was autogenerated from Configuration manager API
// Endpoint: https://configurationmanager.oriflame.com/hierarchy/environments/config.json
// Run `npm run codegen` to regenerate.

const azureRegionsRaw = exports.azureRegionsRaw = ['CE2', 'EA', 'SCUS', 'WE'];
const azureRegions = exports.azureRegions = ['ce2', 'ea', 'scus', 'we'];
const azureRegionSchemaRaw = exports.azureRegionSchemaRaw = z.enum(azureRegionsRaw);
const azureRegionSchema = exports.azureRegionSchema = z.enum(azureRegions);
//# sourceMappingURL=AzureRegion.js.map